import { SITE_ROUTES } from "@/config/siteRoutes";
import { CmsManagedPage } from "@/pages/EditorialPages/CmsManagedPage";
import type { CmsContentPageData } from "@/pages/shared/cmsContent";

const fallback: CmsContentPageData = {
  id: 5,
  slug: "our-mission",
  title: "Our Purpose",
  intro:
    "The mission connecting luxury events with creative technology, strategic direction and authored follow-through.",
  seoTitle: "Our Purpose",
  searchDescription:
    "VenueX mission page focused on meaningful experience, strategic partnership and continuity before, during and after the event.",
  url: SITE_ROUTES.mission,
  bodyHtml: "",
  sections: [],
  paragraphs: [
    {
      html: "<p>We make each event real by turning it into a distinctive, meaningful experience that fully reflects the needs, direction and philosophy of the client behind it.</p>",
      text: "We make each event real by turning it into a distinctive, meaningful experience that fully reflects the needs, direction and philosophy of the client behind it.",
    },
    {
      html: "<p>VenueX does not simply coordinate events. We connect organisation, aesthetics, technology and experience so the whole project feels coherent rather than assembled from separate parts.</p>",
      text: "VenueX does not simply coordinate events. We connect organisation, aesthetics, technology and experience so the whole project feels coherent rather than assembled from separate parts.",
    },
    {
      html: "<p>Whether the work begins from live production, brand language or digital visibility, the standard should remain stable from first brief to final celebration.</p>",
      text: "Whether the work begins from live production, brand language or digital visibility, the standard should remain stable from first brief to final celebration.",
    },
    {
      html: "<p>The mission matters because the message should keep working before the event, during the live moment and long after the lights go down.</p>",
      text: "The mission matters because the message should keep working before the event, during the live moment and long after the lights go down.",
    },
  ],
};

export function OurMissionPage() {
  return (
    <CmsManagedPage
      slug="our-mission"
      currentPath={SITE_ROUTES.mission}
      eyebrow="Our purpose"
      visualImage="/static/venuex/live/hero-main.jpg"
      visualAlt="VenueX mission translated into live event execution"
      leadTitle="Where identity becomes experience"
      leadCopy="Brand identity, digital presence and live experience should move together with one clear and cohesive direction."
      routeLinks={[
        { href: SITE_ROUTES.identity, label: "Read the identity layer", meta: "Brand language" },
        { href: SITE_ROUTES.servicesArchive, label: "Continue into services", meta: "Service archive" },
        { href: SITE_ROUTES.contact, label: "Open the first conversation", meta: "Enquiry" },
      ]}
      primaryCtaLabel="Contact VenueX"
      primaryCtaHref={SITE_ROUTES.contact}
      secondaryCtaLabel="View portfolio"
      secondaryCtaHref={SITE_ROUTES.portfolio}
      hideHeroIntro
      hideConnectedIntro
      connectedTitle="Explore VenueX"
      fallback={fallback}
    />
  );
}
